import React from 'react';
import { TERMS_OF_SERVICE } from '../config/legalContent';
import { LegalDocument } from './LegalDocument';

interface TermsOfServicePageProps {
    onClose?: () => void;
}

export const TermsOfServicePage: React.FC<TermsOfServicePageProps> = ({ onClose }) => {
    return (
        <main className="flex flex-col flex-1 self-stretch rounded-2xl bg-grayscale-100 shadow-custom-light p-6 gap-6 overflow-y-auto hide-scrollbar overflow-x-hidden">
            {/* Header */}
            <div className="flex items-center justify-between border-b border-grayscale-800 pb-4">
                <h1 className="text-grayscale-1300 font-grotesk text-xl font-medium">
                    Terms of Service
                </h1>
                {onClose && (
                    <button 
                        onClick={onClose} 
                        className="px-4 py-2 text-grayscale-900 hover:text-grayscale-1300 font-grotesk text-sm border border-primary-200 rounded-lg hover:bg-primary-50 transition-colors"
                    >
                        Back
                    </button>
                )}
            </div>

            {/* Content */}
            <div className="flex flex-col gap-6 text-grayscale-1200 font-grotesk">
                <LegalDocument doc={TERMS_OF_SERVICE} />
            </div>
        </main>
    );
};
